var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"CollectionBack",style:({backgroundImage:'url('+ _vm.IMG_BASE_URL +_vm.pic+') '}),attrs:{"href":_vm.PAGE_PATH.BASE_URL+ _vm.PAGE_PATH.TOPIC.DEFAULT,"target":"_blank"}},[_c('span',[_vm._v("返回专题列表")])])
}
var staticRenderFns = []

export { render, staticRenderFns }